/* eslint-disable eag/match-named-export, eag/no-index -- Pre-existing grab-bag file with several exports. Pre-existing violation */
export const VISIBLE_TYPE = 'visible';
export const MANDATORY_TYPE = 'mandatory';
export const SECOND_SET_KEY_PARAM_VALUE_MAP: Record<string, string> = {
  secondSetComplete: 'COMPLETE_SET',
  secondSetOnlyRims: 'RIMS_ONLY',
  secondSetOnlyPneus: 'TIRES_ONLY',
};
